
import { Component, Prop, Vue } from 'vue-property-decorator';
import html2canvas from 'html2canvas';
import { getCustomerQrCodeList, qrCodeTemplate } from '@/api/customer';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'CustomerQrcodeDownload',
  components: {

  }
})
export default class extends Vue {
  private codeList:any = []
  private content = '报修请扫此码'
  private platformName = '';
  private webSite = ''
  private bgImage = ''
  private serviceProviders=''
  private templateList: any = []
  private loadingDown = false
  private codeVisible = false
  private templateSelected = ''
  private customerList=[]

  created() {
    this.customerList = JSON.parse(this.$route.query.customerList as string);
    this.getCustomerQrCodeList();
  }
  private getCustomerQrCodeList() {
    let arr = [];
    for (let index = 0; index < this.customerList.length; index++) {
      const element:any = this.customerList[index];
      arr.push(element.id);
    }
    let pamars:any = {};
    pamars.company_id = UserModule.getCompanyId;
    pamars.user_id = UserModule.getUserId;
    pamars.relation_id = arr.join(',');
    getCustomerQrCodeList(pamars).then(res => {
      if (res.data) {
        this.codeList = res.data.list;
      } else {
        this.codeList = [];
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }

  private codeSetHandle() {
    this.codeVisible = true;
    this.qrCodeTemplate();
  }
  // 模版
  private qrCodeTemplate() {
    let pamars:any = {};
    pamars.company_id = UserModule.getCompanyId;
    pamars.user_id = UserModule.getUserId;
    qrCodeTemplate(pamars).then(res => {
      if (res.data) {
        this.templateList = res.data;
      } else {
        this.templateList = [];
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }
  private batchDownload() { // 批量下载
    this.loadingDown = true;
    window.scrollTo(0, 0);
    (document.querySelector('.qrcode-items') as any).style.position = 'fixed';
    let code = document.querySelectorAll('.qrcode-items li');
    let that = this;

    for (let i = 0; i < code.length; i++) {
      html2canvas(code[i] as any, {
        useCORS: true
      }).then(function(canvas: any) {
        let image = new Image();
        image.src = canvas.toDataURL('image/png');
        let a = document.createElement('a');
        a.appendChild(image);
        a.href = image.src;
        a.download = that.codeList[i].customer_company_name;
        a.click();

        if (i === code.length - 1) {
          that.loadingDown = false;
        }
      });
    }

    (document.querySelector('.qrcode-items') as any).style.position = 'static';
  }
  private codeConfirmHandle() {
    this.bgImage = this.templateList[this.templateSelected].image_real_path;
    this.content = this.templateList[this.templateSelected].content;
    this.platformName = this.templateList[this.templateSelected].platform_name;
    this.serviceProviders = this.templateList[this.templateSelected].service_providers;
    this.webSite = this.templateList[this.templateSelected].web_site;
    this.codeVisible = false;
  }
}

